/**
 * 挑战落地横幅。只认白名单路径和数字参数，不把查询串原文写进页面。
 */

const SCORE_MAX = 999999
const ELAPSED_MAX = 24 * 60 * 60
const LEVEL_MAX = 9999

const SUDOKU_LABEL: Record<string, string> = {
  easy: '简单',
  medium: '中等',
  hard: '困难',
  expert: '专家',
}

function boundedInt(raw: string | null, min: number, max: number): number | null {
  if (raw == null || !/^\d+$/.test(raw)) return null
  const value = Number(raw)
  if (value < min || value > max) return null
  return value
}

function clock(seconds: number): string {
  const minute = Math.floor(seconds / 60)
  const second = seconds % 60
  return `${String(minute).padStart(2, '0')}:${String(second).padStart(2, '0')}`
}

/** 当前地址不带挑战参数时返回空字符串。 */
export function challengeMessage(pathname: string, params: URLSearchParams): string {
  if (params.get('from') !== 'challenge') return ''
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname

  if (/^\/riddle\/\d+$/.test(path)) {
    return '你的好友向你发起一道谜题挑战！独立思考，看看你能否猜中谜底？'
  }
  if (path === '/game/2048') {
    const score = boundedInt(params.get('score'), 1, SCORE_MAX)
    if (score != null) return `好友分享了 2048 的 ${score} 分，来试试你的成绩。`
    return '好友邀请你来玩 2048。'
  }
  if (path === '/game/sudoku') {
    const label = SUDOKU_LABEL[params.get('difficulty') || '']
    const elapsed = boundedInt(params.get('elapsed'), 0, ELAPSED_MAX)
    if (label && elapsed != null) {
      return `好友分享了标准数独（${label}）用时 ${clock(elapsed)}，来试试你的成绩。`
    }
    if (label) return `好友邀请你来挑战${label}数独。`
    return '好友邀请你来玩标准数独。'
  }
  const level = path.match(/^\/game\/chengyu-tianci-jielong\/level\/(\d+)$/)
  if (level) {
    const levelNo = boundedInt(level[1], 1, LEVEL_MAX)
    if (levelNo != null) return `好友通过了成语填字接龙第 ${levelNo} 关，来试试这一关。`
    return '好友邀请你来玩成语填字接龙。'
  }
  if (path.startsWith('/game/')) return '好友邀请你来挑战这局。'
  return '欢迎来到谜语猜。'
}
